import { writable, derived, readable } from 'svelte/store';

export type Notification = {
  id: string,
  icon: string,
  title: string,
  subtitle?: string,
  isExpired: boolean,
  actionCTA?: string,
  action?: () => void,
}


const defaultStore = {
  notifications: [] as Notification[],
};

export const store = {
  notifications: writable([...defaultStore.notifications]),
  displayNotification: readable([] as Notification[])
};

store.displayNotification = derived([
  store.notifications
], ([
  $notifications,
]) => {
  return $notifications.filter((n) => !n.isExpired)
})


export function resetStore() {
  store.notifications.set([...defaultStore.notifications])
}
